<template>
    <div class="common-form-wrapper">
        <div class="wrapper">
            <span v-if="$v.value.name.$invalid" class="tooltiptext">{{
                errorDisplay($v.value.name, { val: MAX_NAME_LENGTH })
            }}</span>
            <div class="input-with-insidelabel" :class="{ tooltiperror: $v.value.name.$invalid }">
                <input
                    id="forAT_ResidentProfileName"
                    ref="profileName"
                    :value="value.name"
                    group="main"
                    @input="update('name', $event.target.value) && $v.value.name.$touch()"
                />
                <label for="forAT_ResidentProfileName">{{ $t('sensors.residentProfilesTab.name') }}</label>
            </div>
        </div>
        <div class="wrapper">
            <span v-if="$v.value.description.$invalid" class="tooltiptext">{{
                errorDisplay($v.value.description, { val: MAX_DESCRIPTION_LENGTH })
            }}</span>
            <div
                class="textarea-with-insidelabel has-5-rows"
                :class="{ tooltiperror: $v.value.description.$invalid }"
            >
                <textarea
                    id="forAT_ResidentProfileComment"
                    :value="value.description"
                    group="main"
                    @input="update('description', $event.target.value) && $v.value.description.$touch()"
                ></textarea>
                <label for="forAT_ResidentProfileComment">{{
                    $t('sensors.residentProfilesTab.description')
                }}</label>
            </div>
        </div>
        <form novalidate>
            <div class="wrapper-pattern">
                <div class="chkbox">
                    <input
                        id="listenIn"
                        type="checkbox"
                        :checked="value.listen_in"
                        @change="update('listen_in', $event.target.checked)"
                    />
                    <label for="listenIn"></label>
                    <label for="listenIn">{{ $t('sensors.residentProfilesTab.listenIn') }}</label>
                </div>
                <div class="chkbox">
                    <input
                        id="enableTimeWin"
                        type="checkbox"
                        :checked="value.time_window_enabled"
                        @change="update('time_window_enabled', $event.target.checked)"
                    />
                    <label for="enableTimeWin"></label>
                    <label for="enableTimeWin">{{
                        $t('sensors.residentProfilesTab.enabledTimeWindow')
                    }}</label>
                </div>
            </div>
            <div class="time-window">
                <div class="col-xs-4 time-wrapper">
                    <span v-if="!isFromValid()" class="tooltiptext">{{
                        errorDisplay($v.value.time_window_from, { val: getTimeNoSecondsFormat() })
                    }}</span>
                    <input
                        id="forAT_ResidentProfileTimeWindow_from"
                        v-model="formattedTimeFrom"
                        v-on-clickaway="hideDropDownFrom"
                        :class="{ tooltiperror: !isFromValid() }"
                        :disabled="!value.time_window_enabled"
                        :placeholder="$t('sensors.residentProfilesTab.fromPlaceholder')"
                        :maxlength="timeLenght"
                        class="time-input"
                        autocomplete="off"
                        @click.prevent="openFrom = !openFrom"
                        @input="updateTimeFrom($event.target.value)"
                    />
                    <i class="icon-time" style="pointer-events: none"></i>
                    <div v-show="openFrom" class="time-box">
                        <simplebar class="with-border-track">
                            <ul>
                                <li
                                    v-for="(row, index) in times"
                                    :key="index"
                                    @click.prevent="selectItemFrom(row)"
                                >
                                    {{ formatTime(row.value) }}
                                </li>
                            </ul>
                        </simplebar>
                    </div>
                </div>
                <label>&mdash;</label>
                <div class="col-xs-4 time-wrapper">
                    <span v-if="!isToValid()" class="tooltiptext">{{
                        errorDisplay($v.value.time_window_to, { val: getTimeNoSecondsFormat() })
                    }}</span>
                    <input
                        id="forAT_ResidentProfileTimeWindow_to"
                        v-model="formattedTimeTo"
                        v-on-clickaway="hideDropDownTo"
                        :disabled="!value.time_window_enabled"
                        :placeholder="$t('sensors.residentProfilesTab.toPlaceholder')"
                        :maxlength="timeLenght"
                        class="time-input"
                        autocomplete="off"
                        :class="{ tooltiperror: !isToValid() }"
                        @click.prevent="openTo = !openTo"
                        @input="updateTimeTo($event.target.value)"
                    />
                    <i class="icon-time" style="pointer-events: none"></i>
                    <div v-show="openTo" class="time-box">
                        <simplebar class="with-border-track">
                            <ul>
                                <li
                                    v-for="(row, index) in times"
                                    :key="index"
                                    @click.prevent="selectItemTo(row)"
                                >
                                    {{ formatTime(row.value) }}
                                </li>
                            </ul>
                        </simplebar>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script type="text/babel">
import { mixin as clickaway } from 'vue-clickaway';
import {
    minimumLength,
    maximumNameLength,
    forbidden,
    forbiddenNames,
    maximumDescriptionLength,
    timeInterval,
    errorDisplay,
} from '../../../validators';
import { MAX_DESCRIPTION_LENGTH, MAX_NAME_LENGTH, ROUTE_NAMES } from '../../../constants';
import mappingState from '../../common/mappingState';
import simplebar from 'simplebar-vue';
import { formatTime, getTimeNoSecondsFormat } from '../../common/helpers';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import isMatch from 'date-fns/isMatch';

export default {
    components: {
        simplebar,
    },

    mixins: [clickaway, mappingState],

    constants: {
        MAX_NAME_LENGTH,
        MAX_DESCRIPTION_LENGTH,
    },

    props: {
        value: {
            type: Object,
            required: true,
        },

        forbiddenNames: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            openFrom: false,
            openTo: false,
            formattedTimeFrom: '',
            formattedTimeTo: '',
            times: [],
            isFixed: false,
            timeLenght: formatTime('00:00').length,
        };
    },

    watch: {
        value: {
            handler() {
                this.setFormValid(this.areAllFieldsValid());
                this.formattedTimeFrom = this.value.time_window_from
                    ? formatTime(this.value.time_window_from)
                    : this.formattedTimeFrom;
                this.formattedTimeTo = this.value.time_window_to
                    ? formatTime(this.value.time_window_to)
                    : this.formattedTimeTo;
            },
            deep: true,
        },

        '$route.path'() {
            // Hide time window drop down lists when going back/forward in history
            this.hideDropDownFrom();
            this.hideDropDownTo();
            this.formattedTimeFrom = this.value.time_window_from
                ? formatTime(this.value.time_window_from)
                : '';
            this.formattedTimeTo = this.value.time_window_to ? formatTime(this.value.time_window_to) : '';

            if (this.$router.currentRoute.name === ROUTE_NAMES.SENSORS__RESIDENT_PROFILES__ADD) {
                this.$refs.profileName.select();
            }
        },
    },

    mounted() {
        this.$watch('$v.mainValidationGroup.$invalid', () => {
            this.setFormValid(this.areAllFieldsValid());
        });

        if (this.$router.currentRoute.name === ROUTE_NAMES.SENSORS__RESIDENT_PROFILES__ADD) {
            this.$refs.profileName.select();
            this.formattedTimeFrom = this.value.time_window_from
                ? formatTime(this.value.time_window_from)
                : '';
            this.formattedTimeTo = this.value.time_window_to ? formatTime(this.value.time_window_to) : '';
        }
    },

    validations() {
        return {
            formattedTimeFrom: {
                incorrectTime: val => {
                    return this.incorrectTimeChecker(val) && val.length > 0;
                },
            },
            formattedTimeTo: {
                incorrectTime: val => {
                    return this.incorrectTimeChecker(val) && val.length > 0;
                },
            },
            value: {
                name: {
                    minimumLength,
                    maximumNameLength,
                    forbidden,
                    forbiddenNames: (val, rule) => {
                        rule = this.forbiddenNames;
                        return forbiddenNames(val, rule);
                    },
                },
                description: { maximumDescriptionLength, forbidden },
                time_window_from: {
                    incorrectTime: () => {
                        return this.incorrectTimeChecker(this.formattedTimeFrom);
                    },
                    minimumLength,
                    timeInterval: val =>
                        timeInterval({
                            val: val,
                            value: this.value,
                        }),
                },
                time_window_to: {
                    incorrectTime: () => {
                        return this.incorrectTimeChecker(this.formattedTimeTo);
                    },
                    minimumLength,
                    timeInterval: val =>
                        timeInterval({
                            val: val,
                            value: this.value,
                        }),
                },
            },
            mainValidationGroup: ['value.name', 'value.description'],
        };
    },

    created() {
        this.formattedTimeFrom = this.value.time_window_from ? formatTime(this.value.time_window_from) : '';
        this.formattedTimeTo = this.value.time_window_to ? formatTime(this.value.time_window_to) : '';
        for (let i = 0; i < 48; i++) {
            let x = (i < 20 ? '0' : '') + Math.floor(i / 2) + ':' + (i % 2 ? 30 : '00');
            this.times.push({ value: x });
        }
    },

    methods: {
        errorDisplay,
        formatTime,
        getTimeNoSecondsFormat,

        isFromValid() {
            return (
                !this.value.time_window_enabled ||
                (!this.$v.value.time_window_from.$invalid && !this.$v.formattedTimeFrom.$invalid)
            );
        },

        isToValid() {
            return (
                !this.value.time_window_enabled ||
                (!this.$v.value.time_window_to.$invalid && !this.$v.formattedTimeTo.$invalid)
            );
        },

        areAllFieldsValid() {
            return this.isFromValid() && this.isToValid() && !this.$v.mainValidationGroup.$invalid;
        },

        selectItemFrom(item) {
            this.formattedTimeFrom = formatTime(item.value);
            this.update('time_window_from', item.value);
            this.openFrom = false;
        },

        selectItemTo(item) {
            this.formattedTimeTo = formatTime(item.value);
            this.update('time_window_to', item.value);
            this.openTo = false;
        },

        hideDropDownFrom() {
            this.openFrom = false;
        },

        hideDropDownTo() {
            this.openTo = false;
        },

        update(field, item) {
            this.$emit('input', { ...this.value, [field]: item });
        },

        /**
         * Update the time if user type time in field manually
         */
        updateTimeFrom(val) {
            this.formattedTimeFrom = val;
            this.value.time_window_from = null;
            if (!this.$v.formattedTimeFrom.$invalid) {
                let date = parse(val, getTimeNoSecondsFormat(), new Date());
                this.value.time_window_from = format(date, 'HH:mm');
            }
        },

        /**
         * Update the time if user type time in field manually
         */
        updateTimeTo(val) {
            this.formattedTimeTo = val;
            this.value.time_window_to = null;
            if (!this.$v.formattedTimeTo.$invalid) {
                let date = parse(val, getTimeNoSecondsFormat(), new Date());
                this.value.time_window_to = format(date, 'HH:mm');
            }
        },

        incorrectTimeChecker(val) {
            return val.length > 0
                ? isMatch(val, getTimeNoSecondsFormat()) && val.length === this.timeLenght
                : true;
        },
    },
};
</script>
